import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const SaveQuotation = async (formData: {
  id?: string | null;
  customer_id?: string | null;
  quotation_name: string;
  cart_data: any;
  temp_customer_name?: string | null;
  temp_customer_phone?: string | null;
  temp_customer_email?: string | null;
  temp_customer_address?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/quotation/save`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save quotation.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetQuotationsList = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/quotation/list`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load quotations list.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const DeleteQuotation = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/quotation/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete quotation.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const CompleteQuotation = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/quotation/complete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to mark quotation as complete.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const SendQuotationWhatsApp = async (payload: {
  quotation_id: string;
  phone: string;
  pdf_base64: string;
  filename?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/quotation/send-whatsapp`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to send quotation via WhatsApp.",
      error: {
        code: error?.response?.status || 502,
        type: "server_error",
      },
    };
  }
};
